<template>
  <!-- Main Content -->
  <div id="content">
    <!-- Begin Page Content -->
    <div class="container-fluid">
      <!-- Page Heading -->
      <h1 v-if="isEdit" class="h3 mb-2 text-gray-800">Editar Tag</h1>
      <h1 v-else class="h3 mb-2 text-gray-800">Crear Tag</h1>
      <!-- DataTales Example -->
      <div class="card shadow mb-4">

        <div class="card-body">
          <b-form @submit="onSubmit" @reset="onReset" v-if="show">
            <div class="row">

              <div class="col-6">
                <b-form-group id="input-group-3" label="Título:" label-for="input-category">
                  <b-form-group label-for="keyInput" >
                    <b-form-input id="keyInput"  v-model="form.name" required ></b-form-input>
                  </b-form-group>
                </b-form-group>
              </div>
            </div>

            <b-button type="submit" variant="primary">Guardar</b-button>
          </b-form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import router from "../../../../router";

export default {
  data() {
    return {
      form: {
        name: ''
      },
      show: true,
      tagId: null,
      isEdit: false,
      searchQuestions: "",
      examsQuestions: [],
      examQuestions: [],
    }
  },
  methods: {
    populateSelectExams() {
      this.exams = [];
      this.examsResponse = [];
      if (this.form.module) {
        let relatedExams = this.modulesResponse.find(obj => obj.id === this.form.module).exams;
        this.examsResponse = relatedExams;
        this.exams.push({text: 'Selecciona un tag.', value: null})

        for (let item of relatedExams) {
          console.log(item)
          this.exams.push({text: item.description, value: item.id})
        }
      }
    },
    onSubmit(event) {
      event.preventDefault();
      if (this.isEdit) {
        let loader = this.$loading.show({});
        this.$toastr.defaultTimeout = 2000; // default timeout : 5000
        this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
        axios.put(import.meta.env.VITE_API_BASE_URL + "/api/tag/edit/" + this.tagId , this.form, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          }}).then(() => {
          this.$toastr.s(
            "Tag Editado."
          );
          loader.hide();
          router.push({ path: `/admin-panel/Tags` });
        }).catch((err) => {
          loader.hide();
          console.log(err.message);
          this.$toasted.error("Error al editar el tag, posiblemente ya exista alguno con los mismos datos y estado.", {position: 'top-right', duration: 5000});
        });
      }else {
        let loader = this.$loading.show({});
        axios.post(import.meta.env.VITE_API_BASE_URL + "/api/tag/save", this.form, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          }}).then(() => {
          this.$toastr.s(
            "Tag Guardado."
          );
          loader.hide();
          router.push({ path: `/admin-panel/tags` });
        }).catch((err) => {
          loader.hide();
          console.log(err.message);
          this.$toasted.error("Error al crear el tag, posiblemente ya exista alguno con los mismos datos y estado.", {position: 'top-right', duration: 5000});
        });
      }
    },
    onReset(event) {
      event.preventDefault()
    },
  },
  mounted() {
    //this.loadSubexams();

    if (this.$route.params.id) {
      this.tagId = this.$route.params.id;
      this.isEdit = true;
      let loader = this.$loading.show({});
      axios.get(
        import.meta.env.VITE_API_BASE_URL + "/api/tag/" + this.tagId,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          }
        }
      )
      .then((response) => {
       this.form.name = response.data.name;
        this.form.title = response.data.title;
        this.form.key = response.data.key;
        loader.hide();
        if(response.data === '') {
            console.log(response.data)
            this.lesson = [];
            this.examQuestions = [];
            return;
          }
          let data= response.data;

          this.lesson = data;
          this.examQuestions = data;
          loader.hide();
      }).catch((err) => {
        loader.hide();
        console.log(err.message);
      });
    }
  },
  beforeMount() {
    (function () {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-AMS_HTML";
      document.getElementsByTagName("head")[0].appendChild(script);
    })();
  },
}
</script>
